import React from 'react';
import block from 'bem-cn-lite';
import {Comments, Avatars} from '../Components/Comments';
import Controls from './Controls';
import FrameImageArea from './FrameImageArea';
import Repeater from '../Components/Repeater';
import TrialTooltip from '../Components/TrialTooltip';
import { TransitionGroup } from 'react-transition-group';
import { FadeTransition, SlideUpTransition } from '../Components/Transitions';
import createEvent from '../createCustomEvent';
import { I18n } from 'react-i18next';
import i18n from '../i18n';

const frameImages = [
    'https://cdn.wrike.com/image/__cdnu/illustration_nature_1_dfcc1a7c.jpg',
    'https://cdn.wrike.com/image/__cdnu/illustration_nature_2_1748ba49.jpg',
    'https://cdn.wrike.com/image/__cdnu/illustration_nature_3_3f7a768d.jpg',
    'https://cdn.wrike.com/image/__cdnu/illustration_nature_4_dc14be7a.jpg',
    'https://cdn.wrike.com/image/__cdnu/illustration_nature_5_292e5b86.jpg',
    'https://cdn.wrike.com/image/__cdnu/illustration_nature_6_64cff1b5.jpg',
    'https://cdn.wrike.com/image/__cdnu/illustration_nature_7_3cf183af.jpg',
    'https://cdn.wrike.com/image/__cdnu/illustration_nature_8_e22e3756.jpg',
    'https://cdn.wrike.com/image/__cdnu/illustration_nature_8_e22e3756.jpg'
];

block.setup({
    mod: '--',
});

const initialState = {
    isVisibleComments: false,
    isFrameSelected: false,
    isDisabled: false,
    isVisibleRepeater: false,
    isVisibleTrialTooltip: false,
    isPlaying: true,
    imageWrapSize: {},
    markerPosition: null,
    progressLinePosition: 0,
    progressTimeSeconds: 0,
    comments: [],
    selectedImage: frameImages[0]
}

let progressTime = 0;

class VideoProofing extends React.Component {
    state = {...initialState}

    componentDidMount() {
        this.startSlider();
    }

    addComment = (commentText) => {
        const comment = {
            text: commentText,
            time: i18n.t('rightNow'),
            avatar: Avatars.designer,
            markerColor: '#f8008c',
            author: i18n.t('designer')
        }

        const finalComment = {
            text: i18n.t('videoProofing:startTrial'),
            time: i18n.t('rightNow'),
            avatar: Avatars.pm,
            markerColor: '#4488ff',
            author: i18n.t('projectManager')
        }

        const {comments, isDisabled} = this.state;

        if (isDisabled) {
            return false;
        }

        this.setState({
            comments: [...comments, comment, finalComment],
            isCommenting: false,
            isDisabled: true
        });

        window.dispatchEvent(createEvent('VIDEO_PROOFING_ACTION', {detail: 'Added Comment: ' + commentText}));

        setTimeout(this.showRepeater, 5000);
    }

    showRepeater = () => {
        this.setState({
            isVisibleRepeater: true
        });
    }

    setInitialState = () => {
        this.setState({...initialState});
        this.startSlider();

        window.dispatchEvent(createEvent('VIDEO_PROOFING_ACTION', {detail: 'Reloaded Screenshoot'}));
    }

    startSlider() {
        this.setState({
            progressLinePosition: 0,
            progressTimeSeconds: 0
        });

        progressTime = 0;

        this.updateImageTimerId = setInterval(this.updateImage, 3000);
        this.updateProgressBarTimerId = setInterval(this.updateProgressBar, 1000);
    }

    stopSlider() {
        clearInterval(this.updateImageTimerId);
        clearInterval(this.updateProgressBarTimerId);
    }

    addMarker = (markerPosition, imageWrapSize) => {
        const {isDisabled} = this.state;

        if (isDisabled) {
            return false;
        }

        this.setState({
            isVisibleComments: true,
            markerPosition: markerPosition,
            imageWrapSize: imageWrapSize
        });

        window.dispatchEvent(createEvent('VIDEO_PROOFING_ACTION', {detail: 'Added Marker'}));

        if (this.textArea) {
            this.textArea.focus();
        }
    }

    selectFrame = (progressLinePosition, progressTimeSeconds) => {
        const {isDisabled} = this.state;

        if (isDisabled) {
            return false;
        }

        this.setState({
            isFrameSelected: true,
            selectedImage: this.getRandomImage(),
            progressLinePosition: progressLinePosition,
            progressTimeSeconds: progressTimeSeconds,
            isVisibleTrialTooltip: false,
            isPlaying: false
        });

        window.dispatchEvent(createEvent('VIDEO_PROOFING_ACTION', {detail: 'Selected Frame'}));

        this.stopSlider();
    }

    updateImage = () => {
        this.setState({
            selectedImage: this.getRandomImage(),
        });
    }

    updateProgressBar = () => {
        if (progressTime > 230) {
            this.stopSlider();
            this.startSlider();
        }

        progressTime++;

        this.setState({
            progressLinePosition: this.state.progressLinePosition + 2,
            progressTimeSeconds: this.state.progressTimeSeconds + 1
        });
    }

    getRandomImage() {
        const prevImage = this.state.selectedImage;
        const randomImage = frameImages[Math.floor(Math.random() * frameImages.length)];

        return prevImage !== randomImage ? randomImage : this.getRandomImage();
    }

    showTrialTooltip = () => {
        this.setState({
            isVisibleTrialTooltip: true
        });

        window.dispatchEvent(createEvent('VIDEO_PROOFING_ACTION', {detail: 'Clicked on Panel'}));

        clearTimeout(this.timerid);

        this.timerid = setTimeout(this.hideTrialTooltip, 2000);
    }

    hideTrialTooltip = () => {
        this.setState({
            isVisibleTrialTooltip: false
        });
    }

    handleTrialLinkClick = () => {
        window.dispatchEvent(createEvent('REQUEST_TO_FREE_TRIAL'));
        window.dispatchEvent(createEvent('IMAGE_PROOFING_ACTION', {detail: 'Clicked on Free Trial Link'}));
    }

    playPauseHandler = () => {
        const {isPlaying} = this.state;

        if (isPlaying) {
            this.stopSlider();
        } else {
            this.updateImageTimerId = setInterval(this.updateImage, 3000);
            this.updateProgressBarTimerId = setInterval(this.updateProgressBar, 1000);
        }

        this.setState({
            isPlaying: !isPlaying
        });
    }

    render() {
        const b = block('VideoProofing');

        const {
            comments,
            isVisibleComments,
            isDisabled,
            isFrameSelected,
            selectedImage,
            isVisibleRepeater,
            isVisibleTrialTooltip,
            imageWrapSize,
            markerPosition,
            progressLinePosition,
            progressTimeSeconds,
            isPlaying
        } = this.state;

        const isVisibleCommentInput = isVisibleComments && !isDisabled;


        return (
            <I18n>
            {
                (t) => (
                    <div className={b({isFrameSelected: isFrameSelected})}>
                    
                        {
                            !isVisibleComments && !isFrameSelected &&
                            <div className={b('tooltip')}>
                                {t('videoProofing:tooltips.start')}
                            </div>
                        }
        
                        <TransitionGroup>
                            {isVisibleRepeater && 
                                <FadeTransition>
                                    <Repeater onClick={this.setInitialState}/>
                                </FadeTransition>
                            }
                        </TransitionGroup>
        
                        <TransitionGroup>
                            {isVisibleTrialTooltip && 
                                <SlideUpTransition>
                                    <TrialTooltip width={'100%'} />
                                </SlideUpTransition>}
                        </TransitionGroup>
        
                        <FrameImageArea
                            image={selectedImage}
                            isCollapsed={isVisibleComments}
                            onClick={this.addMarker}
                            markerPosition={markerPosition}
                            imageWrapSize={imageWrapSize}
                            isActive={isFrameSelected} />
        
                        {
                            isVisibleComments &&
                            <Comments
                                comments={comments}
                                textAreaRef={(ref) => this.textArea = ref}
                                onSubmitCommentInput={this.addComment}
                                userAvatar={Avatars.designer}
                                onTrialLinkClick={this.handleTrialLinkClick}
                                isVisibleCommentInput={isVisibleCommentInput} />
                        }
        
                        <Controls
                            isDisabled={isDisabled}
                            progressLinePosition={progressLinePosition}
                            progressTimeSeconds={progressTimeSeconds}
                            isVisibleTooltip={!isFrameSelected}
                            onProgressBarClick={this.selectFrame}
                            onPlayPauseClick={this.playPauseHandler}
                            isPlaying={isPlaying}
                            onClick={this.showTrialTooltip}
                            isActiveComments={isVisibleComments} />
                    </div>
                )
            }
            </I18n>
            
        );
    }
}

export default VideoProofing;
